// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OverlayingPopup__container-cdfe2e {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 36px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.OverlayingPopup__container-cdfe2e.OverlayingPopup__theme-standard-bdc87b {
  --overlaying-popup-background: var(--base-10);
  --overlaying-popup-border: 1px solid var(--base-30);
}

.OverlayingPopup__theme-brand-bef784 {
  --overlaying-popup-background: var(--base-10) var(--gradient-10) top / 100% 260px no-repeat;
  --overlaying-popup-border: 1px solid var(--base-30);
}

.OverlayingPopup__overlay-ca1852 {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
  cursor: pointer;
}

.OverlayingPopup__popup-b904e8 {
  border: var(--overlaying-popup-border);
  box-sizing: border-box;
  box-shadow: var(--box-shadow-popover);
  border-radius: 16px;
  overflow: auto;
  background: var(--overlaying-popup-background);
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/OverlayingPopup/OverlayingPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAAF;;AAGA;EACE,6CAAA;EACA,mDAAA;AAAF;;AAGA;EACE,2FAAA;EACA,mDAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,eAAA;AAAF;;AAGA;EACE,sCAAA;EACA,sBAAA;EACA,qCAAA;EACA,mBAAA;EACA,cAAA;EACA,8CAAA;EACA,UAAA;AAAF","sourcesContent":[".container {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 36px;\n  box-sizing: border-box;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.container.theme-standard {\n  --overlaying-popup-background:  var(--base-10);\n  --overlaying-popup-border: 1px solid var(--base-30);\n}\n\n.theme-brand {\n  --overlaying-popup-background:  var(--base-10) var(--gradient-10) top / 100% 260px no-repeat;\n  --overlaying-popup-border: 1px solid var(--base-30);\n}\n\n.overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 2;\n  cursor: pointer;\n}\n\n.popup {\n  border: var(--overlaying-popup-border);\n  box-sizing: border-box;\n  box-shadow: var(--box-shadow-popover);\n  border-radius: 16px;\n  overflow: auto;\n  background: var(--overlaying-popup-background);\n  z-index: 3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OverlayingPopup__container-cdfe2e`,
	"theme-standard": `OverlayingPopup__theme-standard-bdc87b`,
	"themeStandard": `OverlayingPopup__theme-standard-bdc87b`,
	"theme-brand": `OverlayingPopup__theme-brand-bef784`,
	"themeBrand": `OverlayingPopup__theme-brand-bef784`,
	"overlay": `OverlayingPopup__overlay-ca1852`,
	"popup": `OverlayingPopup__popup-b904e8`
};
module.exports = ___CSS_LOADER_EXPORT___;
